// extracted by mini-css-extract-plugin
module.exports = {"container":"edit-drop-menu_container__3IBB0","toggleContainer":"edit-drop-menu_toggleContainer__3xM0F"};